import React, { Component } from 'react';
import styled from 'styled-components';

import { Button, Toast } from '../../../common/components/atoms';
import { ERROR_MESSAGE } from '../../common/constants.js'
import { PopupMessage, POPUP_TYPE } from '../../common/PopupMessage';

/*
props:
 Display: true or false
*/
class UserImportModal extends Component {
    constructor(props) {
        super(props);

        this.refFileInput = React.createRef();
        this.refToast = React.createRef();
        this.state = {
            address: "",
            sheetName: "",
            range: "",
            result: "",
        }
    }

    onChange = (e) => {
        const {name, value} = e.target;
        this.setState({
            [name]: value
        });
    }

    onGetSheetData(result) {
        let retP = [];
        for(let keyA in result) {
            let retC = [];
            for(let keyB in result[keyA]) {
                retC.push(
                    <TData key={keyB}>
                        {result[keyA][keyB]}
                    </TData>
                );
            }
            retP.push(
                <TRow key={keyA}>
                    {retC}
                </TRow>
            );
        }

        this.setState({ sheetData : (
            <Table>
                <TBody>
                    {retP}
                </TBody>
            </Table>
        )});
    }
    onGetSheetError(result) {
        //console.log(result)
    }

    onSuccess = (count) => {
        //console.log(count);
        this.setState({
            result: count + "件をインポートしました"
        });
    }
    onFailure = (status, error) => {
        //console.log(error);
    }

    onClickImport = () => {
        let err = [];
        let syserr = [];
        if(this.props.permission === 0) {
            syserr.push(ERROR_MESSAGE["permission_denied"]);
        }
        if(this.state.address === "") {
            err.push("アドレス" + ERROR_MESSAGE["not_entered"]);
        }
        if(this.state.sheetName === "" || this.state.range === "") {
            err.push("範囲" + ERROR_MESSAGE["not_entered"]);
        }
        if(err.length === 0 && syserr.length === 0){
            this.setState({
                result: ""
            });
            this.props.dispatch({
                type: "LoadStart"
            });
            this.props.dispatch({
                type: 'ImportUsers_Saga',
                sheet: this.state.address,
                range: this.state.sheetName+"!"+this.state.range,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure,
            });
        } else {
            let message = [];
            for(let key in err) {
                message.push(
                    <div key={key}>
                        {err[key]}
                    </div>
                )
            }
            let errMessage;
            if(message.length > 0) {
                errMessage = PopupMessage({
                    type: POPUP_TYPE.INPUT_ERROR,
                    message: message
                });
            }
            message = [];
            for(let key in syserr) {
                message.push(
                    <div key={key}>
                        {syserr[key]}
                    </div>
                )
            }
            let syserrMessage;
            if(message.length > 0) {
                syserrMessage = PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: message
                });
            }
            this.refToast.current.set(0,[
                syserrMessage,
                errMessage
            ]);
        }
    }

    render() {
        const propsToast = {
            timeout: 2000,
            bottom: "50px",
            right: "100px",
        };
        return (
            <Body name="user-import" Display={this.props.display}>
                <Back Display={this.props.display}></Back>
                <Dialog Display={this.props.display}>
                    <ContentsWrap>
                        <Contents>
                            <Header>{"ユーザー情報取り込み"}</Header>
                            <Column>
                                <Title>
                                    アドレス
                                </Title>
                                <Edit>
                                    <input style={{width:"450px"}} name="address" value={this.state.address}
                                                        onChange={this.onChange} />
                                </Edit>
                            </Column>
                            <Row>
                                <Title>
                                    範囲
                                </Title>
                                <Edit>
                                    <input style={{width:"120px"}} name="sheetName" value={this.state.sheetName} placeholder="シート名"
                                                        onChange={this.onChange} />
                                </Edit>
                                <Edit>
                                    <input style={{width:"120px"}} name="range" value={this.state.range} placeholder="セル範囲 ex.A1:B1"
                                                            onChange={this.onChange} />
                                </Edit>
                            </Row>
                            <Row>
                                <Title>
                                    取り込み結果
                                </Title>
                                <Edit style={{width:"310px"}}>
                                    {this.state.result}
                                </Edit>
                            </Row>
                       </Contents>
                    </ContentsWrap>
                    <Controls>
                        <Button 
                            Color="#0077FF" 
                            Width="100px"
                            onClick={this.onClickImport}
                            icon={(<i className="fas fa-file-import" />)}
                            text="インポート"
                        />
                        <Button 
                            Color="#888888" 
                            Width="100px"
                            onClick={this.props.onClickImportClose}
                            text="戻る"
                        />
                    </Controls>
                </Dialog>
                <Toast ref={this.refToast} {...propsToast} />
            </Body>
        );
    }
}

export { UserImportModal };

const Body = styled.div`
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    pointer-events: ${props => (props.Display ? '' : 'none')};
`;

const Back = styled.div`
    position: absolute;
    top: 0;
    left: 0;

    background-color: #000;
    opacity: ${props => (props.Display ? '0.2' : '0')};
    transition-duration: 0.2s;

    width: 100%;
    height: 100%;
`;

const Dialog = styled.div`
    position: absolute;
    top: ${props => (props.Display ? '50%' : '47%')};
    left: 50%;
    transform: translate(-50%, -50%);

    background-color: #fff;
    opacity: ${props => (props.Display ? '1' : '0')};
    text-align: center;
    transition-duration: 0.2s;
    border-radius: 5px;
`;

const ContentsWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    font-size: 14px;
`;
const Contents = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    position: relative;
`;

const Header = styled.div`
    color: #888;
    font-size: 18px;
    text-align: center;
    width: 100%;
    margin-bottom: 10px;
    font-weight: bold;
`;

const Column = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin: 2px 0;
`;
const Row = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 2px 0;
`;
const Title = styled.div`
    background-color: #888;
    color: #fff;
    width: 150px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
`;
const Edit = styled.div`
    min-width: 150px;
    min-height: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #888;
    margin-right: 10px;
    max-width: 490px;

    input {
        border-radius: 0;
        border: none;
        color: #888;
    }
`;

const Controls = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
`;

const Table = styled.table`
    border-collapse: collapse;
`;
const TBody = styled.tbody`
`;
const TRow = styled.tr`
`;
const TData = styled.td`
    border: 1px solid #888;
    color: #888;
    padding: 2px 5px;
`;
